



























import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import multiselect from 'vue-multiselect';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName } from '../../core/utils';
import Sortable from 'sortablejs';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';

@Component({
    components: {}
})
export default class ConfirmationDialog extends Mixins(
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
) {
    @Prop() title: object;
    @Prop() message: object;
    @Prop() action: string;
    @Prop() visible: boolean;

    mounted() {}

    @Emit()
    closeModal() {}

    confirmAction() {
        this.$emit('confirm-yes');
    }
}
